module.exports = __webpack_public_path__ + "static/media/mbr-1290x1024.b7b94ccd.png";